var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('polaris-card', {
    attrs: {
      "sectioned": ""
    }
  }, [_c('polaris-setting-action', [_c('polaris-stack', {
    slot: "children"
  }, [(_vm.connected && _vm.avatarUrl) ? _c('polaris-stack-item', [_c('span', {
    staticClass: "Polaris-Avatar Polaris-Avatar--styleSix Polaris-Avatar--hasImage Polaris-Avatar--sizeMedium",
    attrs: {
      "aria-label": _vm.realTitle,
      "role": "img"
    }
  }, [_c('img', {
    staticClass: "Polaris-Avatar__Image",
    attrs: {
      "src": _vm.avatarUrl,
      "alt": "",
      "role": "presentation"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('polaris-stack-item', {
    attrs: {
      "fill": ""
    }
  }, [_c('div', {
    staticClass: "Polaris-AccountConnection__Content"
  }, [_vm._t("title", [_c('div', [_vm._v(_vm._s(_vm.realTitle))])]), _vm._v(" "), (_vm.details || this.$slots.details) ? _c('div', [_c('polaris-text-style', {
    attrs: {
      "variation": "subdued"
    }
  }, [_vm._t("details", [_vm._v("\n                                " + _vm._s(_vm.details) + "\n                            ")])], 2)], 1) : _vm._e()], 2)])], 1), _vm._v(" "), _c('polaris-button', {
    attrs: {
      "primary": !_vm.connected,
      "url": _vm.action.url,
      "destructive": _vm.action.destructive,
      "disabled": _vm.action.disabled,
      "icon": _vm.action.icon,
      "accessibility-label": _vm.action.accessibilityLabel
    },
    on: {
      "click": function($event) {
        _vm.handleAction(_vm.action)
      }
    },
    slot: "action"
  }, [_vm._v("\n            " + _vm._s(_vm.action.content) + "\n        ")])], 1), _vm._v(" "), (_vm.$slots.default || _vm.$slots.termsOfService || _vm.termsOfService) ? _c('div', {
    staticClass: "Polaris-AccountConnection__TermsOfService"
  }, [_vm._t("default", [_vm._t("termsOfService", [_vm._v("\n                " + _vm._s(_vm.termsOfService) + "\n            ")])])], 2) : _vm._e()], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1333b89c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1333b89c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisAccountConnection.vue
// module id = 135
// module chunks = 0